import React from 'react';
import type { FC } from 'react';
import type { TOptionShape } from '@alfa-bank/site-select-v2/src/models/common';

import { getInputValue } from './utils';
import type { TSelectDesktop } from './models/desktop';
import type { TSelectMobile } from './models/mobile';
import { useFormSelect } from './hooks/use-form-select';

/** Селект */
export const Select: FC<TSelectDesktop | TSelectMobile> = ({
    BaseSelect,
    Field,
    children,
    className,
    dataTestId = 'form-select',
    defaultInputSufix = 'keys',
    error,
    initialValueIndex,
    limitDynamicOptionGroupSize,
    name,
    onChange,
    onOpen,
    optionsListWidth,
    settings,
    size,
    validationRules,
    valueKey = 'content',
    valueRenderer,
}) => {
    const {
        allowUnselect = false,
        block = true,
        caption,
        multiple,
        options,
        hint = caption,
    } = settings;
    const { currentValueKey, formatedOptions, initialValue, validate } = useFormSelect({
        options,
        valueKey,
        initialValueIndex,
        validationRules,
        multiple,
    });

    return (
        <Field<TOptionShape[]>
            data={settings}
            initialValue={initialValue as TOptionShape[]}
            name={name}
            render={({ input, meta }) => {
                return (
                    <div className={className}>
                        <BaseSelect
                            {...input}
                            {...settings}
                            allowUnselect={allowUnselect}
                            block={block}
                            dataTestId={dataTestId}
                            error={error || ((meta.touched && meta.error) ?? meta.submitError)}
                            hint={hint}
                            limitDynamicOptionGroupSize={limitDynamicOptionGroupSize}
                            // у селекта в корах на каждый выбранный пункт создается отдельный hidden-input
                            // чтобы не смешивать значения из нашего инпута (см.ниже) передаем встроенным инпутам другой name
                            name={`${input.name}-${defaultInputSufix}`}
                            onChange={({ selectedMultiple }) => {
                                input.onChange(selectedMultiple);
                                input.onBlur();
                                onChange?.(selectedMultiple);
                            }}
                            onOpen={onOpen}
                            options={formatedOptions}
                            optionsListWidth={optionsListWidth}
                            selected={input.value.map(option => option.key)}
                            size={size}
                            valueRenderer={valueRenderer}
                        >
                            {children}
                        </BaseSelect>
                        <input
                            name={input.name}
                            type="hidden"
                            value={getInputValue(input.value, currentValueKey)}
                        />
                    </div>
                );
            }}
            validate={validate}
        />
    );
};
